import { Chip, type ChipProps } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import { LogoJarlsberg, LogoNorvegia, LogoSelbuBlaa, LogoYt } from "@tine/web-logos";
import type { ReactNode } from "react";
import type { BrandType } from "../../common/types/productTypes";
import IconBiola from "../navigation/theme/tine/brands/IconBiola";
import IconFjordland from "../navigation/theme/tine/brands/IconFjordland";
import IconGomorgen from "../navigation/theme/tine/brands/IconGomorgen";
import IconGryr from "../navigation/theme/tine/brands/IconGryr";
import IconIsklar from "../navigation/theme/tine/brands/IconIsklar";
import IconKos from "../navigation/theme/tine/brands/IconKos";
import IconKremgo from "../navigation/theme/tine/brands/IconKremgo";
import IconLitago from "../navigation/theme/tine/brands/IconLitago";
import IconNoisy from "../navigation/theme/tine/brands/IconNoisy";
import IconOstavind from "../navigation/theme/tine/brands/IconOstavind";
import IconPiano from "../navigation/theme/tine/brands/IconPiano";
import IconSnofrisk from "../navigation/theme/tine/brands/IconSnofrisk";
import IconSunniva from "../navigation/theme/tine/brands/IconSunniva";
import IconTine from "../navigation/theme/tine/brands/IconTine";
import IconYoplait from "../navigation/theme/tine/brands/IconYoplait";

type BrandGroupChipProps = { brandGroup: BrandType } & ChipProps;

type IconProps = {
   icon?: ReactNode;
   iconPosition?: "left";
};

const BrandGroupChip = ({ brandGroup, children, checked, className, ...props }: BrandGroupChipProps) => {
   const addProps: IconProps = {
      iconPosition: "left"
   };
   const chipClassName = cn(className, "!tw-border tw-border-solid !tw-border-ink-border-subtle tw-text-sm");

   const svgIconStyle = cn("tw-h-[24px]", { "tw-fill-current tw-text-white": checked });

   switch (brandGroup) {
      case "Gryr":
         addProps.icon = <IconGryr color="currentColor" className={svgIconStyle} />;
         break;
      case "YT":
         addProps.icon = <LogoYt className={svgIconStyle} />;
         break;
      case "Sunniva":
         addProps.icon = <IconSunniva className={svgIconStyle} {...(checked ? { color: "currentColor" } : {})} />;
         break;
      case "Snofrisk":
         addProps.icon = <IconSnofrisk color="currentColor" className={svgIconStyle} />;
         break;
      case "Noisy":
         addProps.icon = <IconNoisy color="currentColor" className={svgIconStyle} />;
         break;
      case "Litago":
         addProps.icon = <IconLitago className={svgIconStyle} {...(checked ? { color: "currentColor" } : {})} />;
         break;
      case "Biola":
         addProps.icon = <IconBiola color="currentColor" className={svgIconStyle} />;
         break;
      case "Norvegia":
         addProps.icon = <LogoNorvegia className={svgIconStyle} />;
         break;
      case "Jarlsberg":
         addProps.icon = <LogoJarlsberg className={svgIconStyle} />;
         break;
      case "GoMorgen":
         addProps.icon = <IconGomorgen color={checked ? "#ffffff" : "#000000"} className={svgIconStyle} />;
         break;
      case "Fjordland":
         addProps.icon = <IconFjordland className={svgIconStyle} />;
         break;
      case "Isklar":
         addProps.icon = <IconIsklar color="currentColor" className={svgIconStyle} />;
         break;
      case "Ostavind":
         addProps.icon = <IconOstavind className={svgIconStyle} />;
         break;
      case "Yoplait":
         addProps.icon = <IconYoplait color="currentColor" className={svgIconStyle} />;
         break;
      case "Piano":
         addProps.icon = (
            <IconPiano
               className={svgIconStyle}
               style={checked ? { backgroundColor: "#fff", borderRadius: "50%", width: "24px" } : { width: "24px" }}
            />
         );
         break;
      case "Kremgo":
         addProps.icon = <IconKremgo color="currentColor" className={svgIconStyle} />;
         break;
      case "Kos":
         addProps.icon = <IconKos color="currentColor" className={svgIconStyle} />;
         break;
      case "SelbuBlaa":
         addProps.icon = <LogoSelbuBlaa className={svgIconStyle} />;
         break;
      case "Other":
         break;

      default:
         addProps.icon = <IconTine color="currentColor" className={svgIconStyle} />;
   }

   return (
      <Chip {...props} {...addProps} checked={checked} className={chipClassName}>
         {children}
      </Chip>
   );
};

export default BrandGroupChip;
